export default __webpack_public_path__ + "static/media/f_column.910ab2b7.svg";